import React, { useEffect, useState } from 'react';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { usePatientMutation } from "~/api/patient/usePatientMutation";
import { CachedOutlined } from "@mui/icons-material";
import "@fontsource/lato";
import { useQueryClient } from 'react-query';
export const PatientReportLastAppointmentDate = (props) => {
    const { patient } = props;
    const [selectedDate, setSelectedDate] = React.useState(dayjs(new Date()));
    const [dateColor, setDateColor] = useState('#2C78EB');
    const [label, setLabel] = useState('');
    const [openDateCalendar, setOpenDateCalendar] = useState(false);
    const { mutateAsync } = usePatientMutation();
    const queryClient = useQueryClient();
    const clearAppointmentDate = async () => {
        const patientId = patient.id;
        await mutateAsync({ patientId, lastAppointment: 'null' });
        setSelectedDate(null);
        setDateColor('#2C78EB');
        setLabel('');
        patient.lastAppointment = null;
        queryClient.invalidateQueries(['getPatientTimeline', patient.id]);
    };
    const updateAppointmentDate = async (value) => {
        const patientId = patient.id;
        await mutateAsync({ patientId, lastAppointment: value.format('YYYY-M-D').toString() });
        updateAppointmentText(value);
        patient.lastAppointment = new Date(value.format('YYYY-M-D').toString());
        queryClient.invalidateQueries(['getPatientTimeline', patient.id]);
    };
    const updateAppointmentText = (value) => {
        const today = dayjs().format('YYYY-M-D');
        if (value.isSame(today)) {
            setDateColor('#42A5F5');
            setLabel('Today');
        }
        if (value.isAfter(today)) {
            setDateColor('#00000099');
            setLabel('');
        }
        if (value.isBefore(today)) {
            setDateColor('#00000099');
            // setDateColor('#EF5350');
            setLabel('');
        }
    };
    useEffect(() => {
        if (patient.lastAppointment) {
            setSelectedDate(dayjs(patient.lastAppointment));
            updateAppointmentText(dayjs(patient.lastAppointment));
        }
        else {
            setSelectedDate(null);
        }
    }, []);
    return (React.createElement("div", null,
        React.createElement("div", { style: { width: '100%', marginBottom: '10px', textAlign: 'left' } },
            React.createElement("span", { style: { color: '#00000099', fontSize: 12, fontFamily: 'Barlow', fontWeight: '500', marginRight: '5px' } }, "Last Appointment:"),
            React.createElement("span", { style: { color: dateColor, fontSize: 12, fontFamily: 'Barlow', fontWeight: '500' } }, label)),
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '8px' } },
            React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                React.createElement(DatePicker, { open: openDateCalendar, onOpen: () => setOpenDateCalendar(true), onClose: () => setOpenDateCalendar(false), slotProps: {
                        textField: {
                            size: 'small',
                            onClick: () => setOpenDateCalendar(true),
                        },
                    }, label: '', value: selectedDate, maxDate: dayjs(), onChange: (value) => {
                        updateAppointmentDate(dayjs(value));
                        setSelectedDate(value);
                    } })),
            React.createElement("span", null,
                React.createElement(CachedOutlined, { style: { visibility: selectedDate ? 'visible' : 'hidden', float: 'right', cursor: 'pointer' }, color: 'primary', onClick: () => { if (selectedDate)
                        clearAppointmentDate(); } })))));
};
